import { useEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const LeadGraphChart = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!data || data.length === 0) return;

    const root = am5.Root.new(chartRef.current);

    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
      })
    );

    // X Axis (labels)
    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "name", // ✅ FIXED: matched to "name" in your data
        renderer: am5xy.AxisRendererX.new(root, {
          minGridDistance: 30,
        }),
      })
    );

    xAxis.get("renderer").grid.template.setAll({
      forceHidden: true,
    });

    xAxis.data.setAll(data);

    // Y Axis (values)
    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
      })
    );

    yAxis.get("renderer").labels.template.setAll({
      forceHidden: true,
    });

    // Series (bars)
    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Leads",
        xAxis,
        yAxis,
        valueYField: "total",  // Matches "total" in your data
        categoryXField: "name", // ✅ FIXED: matched to "name" in your data
        tooltip: am5.Tooltip.new(root, {
          labelText: "{categoryX}: {valueY}",
        }),
      })
    );

    series.data.setAll(data);

    // Value Labels on Top of Bars
    series.bullets.push(() => {
      return am5.Bullet.new(root, {
        locationY: 1, // Top of bar
        sprite: am5.Label.new(root, {
          text: "{valueY}",
          populateText: true,
          centerX: am5.p50,
          centerY: am5.p100, // Anchor above bar
          dy: -10, // Position slightly above column top
          fill: am5.color("#000"),
          fontSize: 14,
          fontWeight: "700",
        }),
      });
    });

    // Styling
    series.columns.template.setAll({
      fill: am5.color("#105B3D"),
      cornerRadiusTL: 5,
      cornerRadiusTR: 5,
      strokeOpacity: 0,
    });

    series.appear(1000);
    chart.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [data]);

  return <div ref={chartRef} style={{ width: "100%", height: "400px" }} />;
};

export default LeadGraphChart;